import { IonGrid, IonText, IonImg, IonAlert, IonFabButton, IonFab, IonSearchbar, IonInfiniteScrollContent, IonInfiniteScroll, IonIcon, IonRefresherContent, IonRefresher, IonBackButton, IonButton, IonButtons, IonCard, IonCheckbox, IonCol, IonContent, IonHeader, IonInput, IonItem, IonLabel, IonList, IonPage, IonRow, IonTitle, IonToolbar, useIonViewWillEnter } from "@ionic/react";
import React, { useState } from "react";
import BlockUserItem from "../components/BlockUserItem";
import { Beneficiary } from "../data/beneficiaries";
import { Message, getMessages } from "../data/messages";
import { addOutline } from 'ionicons/icons';

import { LANGUAGE, GetStr } from "../language/Language";
import { Storage } from '@capacitor/storage';   
import NServer from "../components/NServer";
import Vault from '../components/Vault';
import { showAlert } from '../components/Alert';

import './Main.css';  

var index = 0;
const total = 10;
var curUnblockUser = -1;

const BlockList : React.FC = () => {
    const [beneficiaries, setBeneficiaries] = useState<Beneficiary[]>([]);
    
    const [noMoreLoadData, setNoMoreLoadData] = useState(false);
    const [ask, setAsk] = useState(false);

    useIonViewWillEnter(() => {
        index = 0;
        getData();
    });

    const getData = async () => {

        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            s : index,
            e : total
        }

        var server = new NServer();
        await server.getList("block_users", state);
        if (server.success)
        {
            if (index == 0)
                setBeneficiaries(server.data);
            else
		        setBeneficiaries(beneficiaries.concat(server.data));

            // if we reach end of data
            if (server.data.length < total)
                setNoMoreLoadData(true);
        }
	}

    const doRefresh = async (ev : any) => {
        // start from beginning
        setNoMoreLoadData(false);
        index = 0;
        
        await getData();
        ev.detail.complete();
    };

    const loadMoreData = async (ev: any) => {
        // increase index
        index += total;

        await getData();
        ev.target.complete();
    }  

    const unblock = (id : number) => {
        curUnblockUser = id;
        setAsk(true);
    }

    const DoUnblock = async () => {
        let v = new Vault();
        await v.read();

        const state = {
            id: v.account.id,
            pass: v.account.key,
            user: curUnblockUser
        }

        var server = new NServer();
        await server.sendForm("unblock", state);
        if (!server.success && server.message != "")
            showAlert(server.message);
        else
        {
            index = 0;
            getData();
        }
    }
  
    return (
        <IonPage>
            <IonHeader className="ion-no-border">
                <IonToolbar>
                    <IonButtons slot="start">
                        <IonBackButton text="" defaultHref="/home" ></IonBackButton>
                    </IonButtons>
                    <IonTitle className="title"><h5>{ GetStr(LANGUAGE.TXT_BLOCKLIST_CAP) }</h5></IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent className="bk">
                <IonAlert
                    isOpen={ask}
                    onDidDismiss={() => setAsk(false)}
                    header={GetStr(LANGUAGE.TXT_UNBLOCK_CAP)}
                    message={GetStr(LANGUAGE.TXT_UNBLOCK_LBL)}
                    buttons={[
                        {
                            text: GetStr(LANGUAGE.TXT_CANCEL),
                            role: 'cancel',
                            cssClass: 'secondary',
                            id: 'cancel-button'
                        },
                        {
                            text: GetStr(LANGUAGE.TXT_OK),
                            id: 'confirm-button',
                            handler: () => {
                                DoUnblock();
                            }
                        }
                    ]}
                />
                <IonRefresher  slot="fixed" onIonRefresh={doRefresh}>
                    <IonRefresherContent></IonRefresherContent>
                </IonRefresher>
                {
                    beneficiaries.length > 0 ?
                <IonCard className="flat-card bk-color">
                    <IonList>
                        {beneficiaries.map(m => <BlockUserItem key={m.rid} beneficiary={m} onClick={ unblock } />)} 
                    </IonList>
                    <IonInfiniteScroll
                        onIonInfinite={loadMoreData}
                        threshold="100px"
                        disabled={noMoreLoadData}
                    >
                        <IonInfiniteScrollContent
                            className="ion-no-padding"
                            loadingSpinner="crescent"
                        ></IonInfiniteScrollContent>
                    </IonInfiniteScroll>
                </IonCard>
                    :
                <IonGrid className="ion-no-padding">
                    <IonRow>
                        <IonCol>
                        </IonCol>
                        <IonCol className="ion-text-center" size-md="8" size-lg="6" size-xl="4" size="10">
                            <div><IonText><h4>{ GetStr(LANGUAGE.TXT_INFO_BLOCK_CAP) }</h4></IonText></div>
                            <div><IonImg className="info-pic" src="/assets/img/empty_pic.png" /></div>
                            <div><IonText>{ GetStr(LANGUAGE.TXT_INFO_BLOCK_DESC) }</IonText></div>
                        </IonCol>
                        <IonCol>
                        </IonCol>
                    </IonRow>
                </IonGrid>
                }
            </IonContent>
        </IonPage>
    );
};
export default BlockList;